import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { QuickDispenseResult } from 'app/shared/models/orders-and-billing';

@Injectable()
export class AggregatorQuickDispenseService {

    constructor(private _http: HttpClient) { }

    createQuickDispense(payload: any): Observable<QuickDispenseResult> {
        return this._http.post<QuickDispenseResult>(
            `${environment.httpAggregatorApi}QuickDispense/CreateQuickDispense`,
            payload
        );
    }
}